import { Button, Stack } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import BoxIcon from '@shared/components/BoxIcon';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

type Props = {
  onBook: () => void;
  phone?: string | null;
  email?: string | null;
  allowPublicReservations?: boolean;
};

const ProfileActions = ({ onBook, phone, email, allowPublicReservations = true }: Props) => {
  const { t } = useIntlTranslations('profileActions');
  return (
    <Stack
      spacing={1.5}
      sx={{ mb: 2 }}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {allowPublicReservations ? (
        <Button
          variant="contained"
          size="small"
          startIcon={<CalendarMonthIcon />}
          onClick={onBook}
          sx={{
            bgcolor: '#D02964',
            color: '#fff',
            borderRadius: '14px',
            py: 1.2,
            fontSize: '1rem',
            fontWeight: 700,
            boxShadow: '0 6px 24px rgba(208,41,100,0.35)',
            '&:hover': { bgcolor: '#b52358', color: '#fff' },
          }}
        >
          {t('bookNow')}
        </Button>
      ) : (
        <Button
          variant="outlined"
          size="small"
          startIcon={<PhoneDisabledIcon />}
          component="a"
          href={phone ? `tel:${phone}` : undefined}
          sx={{
            borderColor: '#D02964',
            color: '#D02964',
            borderRadius: '14px',
            py: 1.2,
            fontSize: '1rem',
            fontWeight: 700,
            '&:hover': { bgcolor: '#D0296415' },
          }}
        >
          {t('orderByPhone')}
        </Button>
      )}
      {(phone || email) && (
        <Stack direction="row" spacing={1}>
          {phone && (
            <BoxIcon
              boxColor="common.white"
              href={`tel:${phone}`}
              icon={<PhoneIcon color="success" />}
              size="medium"
            />
          )}
          {phone && (
            <BoxIcon
              boxColor="common.white"
              href={`sms:${phone}`}
              icon={<SmsIcon color="info" />}
              size="medium"
            />
          )}
          {email && (
            <BoxIcon
              boxColor="common.white"
              href={`mailto:${email}`}
              icon={<EmailIcon color="warning" />}
              size="medium"
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default ProfileActions;
